export type ExistingInventoryQuantityArgs =
  | {
      fromInventory: number;
      toInventory: number;
    }
  | {
      balance: number;
    };

export class ExistingInventoryQuantity {
  public static readonly ZERO = new ExistingInventoryQuantity({ balance: 0 });

  public readonly fromInventory: number;
  public readonly toInventory: number;
  public readonly balance: number;

  constructor(args: ExistingInventoryQuantityArgs) {
    if ("balance" in args) {
      this.balance = args.balance;
      if (this.balance > 0) {
        this.fromInventory = this.balance;
        this.toInventory = 0;
      } else {
        this.fromInventory = 0;
        this.toInventory = -this.balance;
      }
    } else {
      this.fromInventory = args.fromInventory;
      this.toInventory = args.toInventory;
      this.balance = this.fromInventory - this.toInventory;
    }
  }

  public isZero(): boolean {
    return this.fromInventory === 0 && this.toInventory === 0;
  }

  public add(other: ExistingInventoryQuantity): ExistingInventoryQuantity {
    return new ExistingInventoryQuantity({
      fromInventory: this.fromInventory + other.fromInventory,
      toInventory: this.toInventory + other.toInventory,
    });
  }
}
